import { createFileRoute, redirect } from "@tanstack/react-router";

/** Legacy EN slug — 301 to the canonical EN URL. */
export const Route = createFileRoute("/en/lemon-thermometer")({
  beforeLoad: () => {
    throw redirect({ to: "/en/leak-detector", statusCode: 301 });
  },
});
